import React, { useCallback, useEffect, useState } from 'react'
import { Button, CircularProgress, Grid, Typography, Box, IconButton, TextField, Paper } from '@mui/material'
import { Edit as EditIcon, Delete as DeleteIcon  } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';

import { useDispatch } from 'react-redux'
import { useScoreResolver } from './useScoreResolver.js'

import useStyles from './styles.js'
import { forfaitMatch, updateMatch } from '../../../actions/matchs.js'
import { useTimer } from './useTimer.js'
import { confirmActionNotification } from '../../../actions/notifications.js'
import { getPeriod, getTotalTimer, getPlayedGamesPeriods, getAllMatchPeriods } from '../sports/rules.js'
import { getGameFactDetail } from '../saisierapide/utils.js'
import { createGameFact } from '../../../actions/gameFact.js'
import { usePeriodButton } from './usePeriodButton.js'
import { updateActuLive } from '../../../actions/actulives.js'

import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import { updateTagsActuLive } from '../../../api/index.js';

const LiveHeader = ({match, enterGameFact, goToGameFact, surchargePeriod, setSurchargePeriod, setLocalTimer = () => {}}) => {

    const classes = useStyles();

    const dispatch = useDispatch()

    const [homeScore, awayScore, , , homeShoutoutSucceed, awayShoutoutSucceed] = useScoreResolver(match)

    const [
        timerValue, 
        updateTimer, 
        timerId, 
        startMatch, 
        stopFirstPeriod, 
        startSecondPeriod, 
        stopSecondPeriod, 
        periodValue,
        stopSecondPeriodToNext,
        startPeriod,
        stopPeriod
    ] = useTimer(match)

    useEffect(() => {
        setLocalTimer(timerValue)

    }, [timerValue])

    const pressTimerButton = () => {
        if(timerValue !== 0){
            if(match.period !== 2 || !['soccer', 'rugby', 'handball'].includes(match.discipline))
                updateTimer((...params) => dispatch(updateMatch(...params, undefined, true)))
        }    
    }

    function padTo2Digits(num) {
        return (num.toString()).padStart(2, '0');
    }


    const getTimer = useCallback(() => {
        if(match.statusTimer === 'off'){
            if(match.status === 'end')
                return 'Fin du match'

            if(match.period === 0 && timerValue===0)
                return '00:00'

                if(['handball'].includes(match.discipline)){
                    const currPeriod = getPeriod(match.period, match.discipline);
                        if (!currPeriod.isPlayable){
                           return currPeriod.name;
                        }
                }else{
                    if(['basket'].includes(match.discipline) && timerValue===0)
                    return 'Quart-temps'
                
                if((match.period === 1 && timerValue===0) || (match.period === 4 && timerValue===0))
                    return 'Mi-temps'
                }
        }

        const totalTimer = getTotalTimer(match.period, timerValue, match.discipline)

        // 👇️ Always get the floor value of totalTimer
        const totalTimerFloor = Math.floor(totalTimer);

        // 👇️ get number of full minutes
        const minutes = Math.floor(totalTimerFloor / 60);

        // 👇️ get remainder of seconds
        const seconds = Math.floor(totalTimerFloor % 60);

        // format as MM:SS
        const result = `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;

        return result

    }, [timerValue, match.period, match.statusTimer, match.status])

    const getColorButton = useCallback(() => {
        return match.statusTimer === 'on'? 'success' : 'error'
    }, [match.statusTimer])

    const saveGameFact = (gameFact, team, defaultDetail) => {
        const getDetails = getGameFactDetail(gameFact)

        if(getDetails){
            const gfDetails = getDetails(match, team, undefined, defaultDetail)
            dispatch(createGameFact(gfDetails, gameFact.id, match))
        }
            
    }

    const getPeriodButton = usePeriodButton({match, timerValue, enterGameFact, goToGameFact, saveGameFact, stopPeriod, startPeriod})

    const getSurchargePeriodButtons = useCallback(() => {
        const buttonsPeriod = []

        if(['handball'].includes(match.discipline)){
            
            const allPeriods = getAllMatchPeriods(match.discipline);
            const allPlayablePeriods = getPlayedGamesPeriods(match.discipline);
            const periodsToDisplay = new Map();

            for (const [key, value] of allPlayablePeriods) {
                if (key <= match.period) {
                    periodsToDisplay.set(value.matchPeriod, value);
                } else {
                    if (!allPeriods.get(match.period).isPlayable){
                        periodsToDisplay.set(value.matchPeriod, value);
                    }
                    break;
                }
            }
           
            for (const [matchPeriod, period] of periodsToDisplay) {
          
                buttonsPeriod.push(<Button sx={{padding:'0px', minWidth : '30px', marginLeft: '2px'}} 
                                                                variant={surchargePeriod===matchPeriod  ? "contained" : "outlined"} 
                                                                size="medium" 
                                                                color={period.playedStepInGame===periodsToDisplay.size ? "success" : "error"}
                                                                onClick={() => setSurchargePeriod(matchPeriod)}
                                                                >{period.playedStepInGame}
                                                        </Button>)
           }

        }else{

            for(var i = 0; i <= match.period ; i++){
                let actualInLoop = i
    
                if(['soccer', 'rugby'].includes(match.discipline)){
                    if(i !== 2)
                        buttonsPeriod.push(<Button sx={{padding:'0px', minWidth : '30px', marginLeft: '2px'}} 
                                                    variant={surchargePeriod===i ? "contained" : "outlined"} 
                                                    size="medium" 
                                                    color={match.period===i ? "success" : "error"}
                                                    onClick={() => setSurchargePeriod(actualInLoop)}
                                                    >{i <= 2 ? i+1 : i}
                                            </Button>)
                }else{
                    buttonsPeriod.push(<Button sx={{padding:'0px', minWidth : '30px', marginLeft: '2px'}} 
                                                variant={surchargePeriod===i ? "contained" : "outlined"} 
                                                size="medium" 
                                                color={match.period===i ? "success" : "error"}
                                                onClick={() => setSurchargePeriod(actualInLoop)}
                                                >{i+1}
                                        </Button>)
                }
            }

        }

        return buttonsPeriod

    }, [match.period, surchargePeriod])

    const matchReported = () => {
        // On passe le status du match à "reported"
        dispatch(confirmActionNotification("Confirmer le report du match", () => dispatch(updateMatch(match.idMatch, {status : 'reported'}))))
    }

    const matchForfait = (team) => {
        dispatch(confirmActionNotification("Confirmer le forfait de : "+team.name, () => dispatch(forfaitMatch(match.idMatch, team._id))))
    }

    const matchFinished = () => {

        let targetPeriod = 0

        switch(match.discipline){
            case 'soccer':
            case 'rugby' :
                targetPeriod = 6
            break
            case 'handball':
                targetPeriod = 10
            break
            case 'basket':
                targetPeriod = 4
            break
        }

        dispatch(confirmActionNotification("Confirmer la fin du match : ", () => dispatch(updateMatch(match.idMatch, {status : 'end', period : 6, timer : 0}))))
    }

    return (
        match && (match.idMatch || match.idActu) ?
        match.homeTeam ? 
        <Box sx={{width : '100%'}}>
            <Grid container py={2} sx={{justifyContent : "center", alignItems : 'center', background : '#3160a338'}}>
                <Grid item xs={3} textAlign={"center"} paddingLeft={'5%'}>
                    <Button sx={{ p: '4px', minWidth: 'auto', fontSize : '0.7em', lineHeight : '0.8em' }} disabled={match.period === 2} variant='contained' size='small' onClick={() => matchForfait(match.homeTeam)}>Forfait</Button>
                </Grid>
                <Grid item xs={6} textAlign={"center"}>
                    <Button sx={{ p: '4px', minWidth: 'auto', fontSize : '0.7em', lineHeight : '0.8em' }} disabled={match.status === 'reported' || match.period === 2} variant='contained' size='small' onClick={matchReported}>Reporté</Button>
                </Grid>
                <Grid item xs={3} textAlign={"center"} paddingRight={'5%'}>
                    <Button sx={{ p: '4px', minWidth: 'auto', fontSize : '0.7em', lineHeight : '0.8em' }} disabled={match.period === 2} variant='contained' size='small' onClick={() => matchForfait(match.awayTeam)}>Forfait</Button>
                </Grid>
                <Grid item xs={1} textAlign={"right"}>
                    {match.homeTeam.logoUrl && <img src={match.homeTeam.logoUrl} style={{width : '90%'}}></img>}
                </Grid>
                <Grid item xs={4} textAlign={"left"} paddingLeft={'5%'}>
                    <Typography sx={{fontSize : '1em', fontWeight : 600}} component={'span'}>{match.homeTeam.name}</Typography>
                </Grid>
                <Grid item xs={2} textAlign={"center"} sx={{display : 'flex', flexDirection : 'column'}}>
                    <Typography variant="h4">{homeScore} - {awayScore}</Typography>
                    {(homeShoutoutSucceed || awayShoutoutSucceed) ? <><Typography sx={{fontSize : '1em'}}>t.a.b</Typography><Typography sx={{fontSize : '1.2em'}}>{homeShoutoutSucceed} - {awayShoutoutSucceed}</Typography></> : null}
                </Grid>
                <Grid item xs={4} textAlign={"right"} paddingRight={'5%'}>
                    <Typography sx={{fontSize : '1em', fontWeight : 600}} component={'span'}>{match.awayTeam.name}</Typography>
                </Grid>
                <Grid item xs={1} textAlign={"left"}>
                    {match.awayTeam.logoUrl && <img src={match.awayTeam.logoUrl} style={{width : '90%'}}></img>}
                </Grid>
                <Grid item xs={4} textAlign={"left"}>
                    {getPeriodButton()}
                </Grid>
                <Grid item xs={4} textAlign={"center"}>

                    {   (timerValue == 0 && periodValue == 0 && match.statusTimer === 'off') ? 
                        <Button sx={{ p: '4px', minWidth: 'auto', fontSize : '0.7em', lineHeight : '0.8em' }} variant="contained" onClick={matchFinished}>FIN DU MATCH</Button> 
                    : 
                        <Button variant="contained" onClick={pressTimerButton} color={getColorButton()} disabled={timerValue === 0 && match.statusTimer === 'off'} size="large" sx={{width : '60%'}}><Typography sx={{fontSize : '1em'}}>{getTimer()}</Typography></Button>
                    }
                    
                    
                </Grid>
                <Grid item xs={2} textAlign={"left"} flexDirection={"row"}>
                    {(match.discipline!== 'handball' && match.status !== 'end' && periodValue !== 2 && periodValue !== 6) && 
                        <>
                            {match.period !== 5 && <Typography 
                                component={'span'} 
                                variant="h5" 
                                sx={{fontSize : '0.8em'}}>
                                    {match.period < 2 ? match.period+1 : match.period-2}
                            </Typography>}
                            <Typography 
                                component={'span'} 
                                variant="h6" 
                                sx={{fontSize : '0.8em'}}>
                                    {match.period === 5 ? 'Tirs au but' : match.period < 2 ? 'e période' : 'e prolongation'}
                            </Typography>
                        </>}
                        {match.discipline !== 'handball' && match.status === 'end' &&
                        <>
                            <Typography 
                                component={'span'} 
                                style={{ fontSize: '0.9rem' }} 
                                sx={{fontSize : '0.8em'}}>
                                    Match terminé
                            </Typography>
                        </>}
                        {match.discipline === 'handball' && 
                        <>
                            <Typography 
                                component={'span'} 
                                style={{ fontSize: '0.9rem' }} 
                                sx={{fontSize : '0.8em'}}>
                                    {getPeriod(match.period, match.discipline).name}
                            </Typography>
                        </>}
                </Grid>
                <Grid item xs={2} textAlign={"center"} flexDirection={"column"}>
                    <Grid item xs={12} textAlign={"center"} display={"flex"} justifyContent={"center"}>
                        <Typography variant="h6" sx={{fontSize : '0.8em'}}>Période de saisie active :</Typography>
                    </Grid>
                    <Grid item xs={12} textAlign={"left"} display={"flex"} justifyContent={"right"}>
                        {getSurchargePeriodButtons()}
                    </Grid>
                </Grid>
            </Grid>
        </Box> : <ActuBox actu={match}/>
        :
        <CircularProgress/>
    )

}

const ActuBox = ({ actu }) => {
    const dispatch = useDispatch();
    const [isEditing, setIsEditing] = useState(false);
    const [editedName, setEditedName] = useState(actu.name);
  
    const handleEdit = () => {
      setIsEditing(true);
    };
  
    const handleSave = () => {
        dispatch(updateActuLive(actu.idActu, {name : editedName}))
        // Fin de l'édition
        setIsEditing(false);
    };
  
    const handleCancel = () => {
      // Annule l'édition et réinitialise le nom édité
      setIsEditing(false);
      setEditedName(actu.name);
    };
  
    const handleChange = (e) => {
      // Met à jour le nom édité en fonction de la saisie utilisateur
      setEditedName(e.target.value);
    };
  
    return (
        <Box>
            <Box sx={{display : 'flex', justifyContent : 'center'}}>
                    {isEditing ? (
                    <Box sx={{display : 'flex', alignItems : 'center'}}>
                        <TextField  
                            sx={{minWidth : '300px'}}
                            inputProps={{
                                style: {
                                padding: 5,
                                }
                            }}
                            type="text" 
                            value={editedName} 
                            onChange={handleChange} 
                        />
                        <IconButton size={"small"} onClick={handleSave}>
                        <DoneIcon />
                        </IconButton>
                        <IconButton size={"small"} onClick={handleCancel}>
                        <CloseIcon />
                        </IconButton>
                    </Box>
                    ) : (
                    <Box sx={{display : 'flex', alignItems : 'center'}}>
                        <Box>{actu.name} <Typography onClick={handleEdit} component="span" variant='subtitle2' bgcolor={'rgb(200,200,200)'} p={1} sx={{'&:hover' : { cursor : 'pointer'}}}><IconButton size={"small"} >
                        <EditIcon />
                        </IconButton>Modifier le titre</Typography></Box>
                        
                    </Box>
                    )}


                    
                </Box>
                <TagsManager actu={actu}/>
        </Box>
      
    );
};


const TagsManager = ({ actu }) => {
    const [tags, setTags] = useState(actu.tags || []); // Initialiser les tags avec ceux de l'actu
    const [newTag, setNewTag] = useState('');
    const [editingTagId, setEditingTagId] = useState(null);
    const [editedTagName, setEditedTagName] = useState('');

    useEffect(() => {

        setTags(actu.tags || [])

    }, [actu.tags])

    const onUpdateTags = async (updatedTags) => {
        try {
            console.log("tags sent ", updatedTags)
          const response = await updateTagsActuLive(actu.idActu, updatedTags);
          console.log('Tags mis à jour :', response.data.tags);
        } catch (error) {
          console.error('Erreur lors de la mise à jour des tags', error);
        }
      };
  
    // Fonction pour ajouter un nouveau tag
    const handleAddTag = () => {
      if (newTag.trim() === '') return;
      const newTagObj = { name: newTag }; // Temporairement, utiliser un ID unique localement
      setTags([...tags, newTagObj]);
      setNewTag('');
      onUpdateTags([...tags, newTagObj]); // Propagate change to parent component or server
    };
  
    // Fonction pour modifier un tag
    const handleEditTag = (id) => {
        console.log("Id ", id)
      const updatedTags = tags.map(tag => tag._id === id ? { ...tag, name: editedTagName } : tag);
      setTags(updatedTags);
      setEditingTagId(null);
      setEditedTagName('');
      onUpdateTags(updatedTags); // Propagate change to parent component or server
    };
  
    // Fonction pour démarrer l'édition d'un tag
    const startEditing = (id, currentName) => {
        console.log("Start editing ", id)
      setEditingTagId(id);
      setEditedTagName(currentName);
    };

    // Fonction pour supprimer un tag
    const handleDeleteTag = (id) => {
        const updatedTags = tags.filter((tag) => tag._id !== id);
        setTags(updatedTags);
        onUpdateTags(updatedTags); // Propagate change to parent component or server
    };
  
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p : 2, m : 2, border:'1px solid #dadada' }}>

<Typography
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#000000c9',
                  color: 'white',
                  padding: '0.25rem',
                  textTransform: 'uppercase',
                  fontSize: 'small',
                }}
              >
                Gestion des tags
              </Typography>

        {/* Liste des tags existants */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {tags.map((tag) => (
            <Box key={tag._id} sx={{ display: 'flex', alignItems: 'center', border: '1px solid gray', borderRadius: '4px', padding: '4px 8px' }}>
              {editingTagId === tag._id ? (
                <TextField
                  size="small"
                  value={editedTagName}
                  onChange={(e) => setEditedTagName(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleEditTag(tag._id)} // Allow Enter to confirm
                />
              ) : (
                <span>{tag.name}</span>
              )}
              {editingTagId === tag._id ? (
                <IconButton size="small" onClick={() => handleEditTag(tag._id)}>
                  <CheckIcon />
                </IconButton>
              ) : (
                <IconButton size="small" onClick={() => startEditing(tag._id, tag.name)}>
                  <EditIcon />
                </IconButton>
              )}

                <IconButton size="small" onClick={() => handleDeleteTag(tag._id)}>
                <DeleteIcon />
                </IconButton>
            </Box>
          ))}
        </Box>
  
        {/* Ajouter un nouveau tag */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TextField
            size="small"
            value={newTag}
            onChange={(e) => setNewTag(e.target.value)}
            placeholder="Créer un tag"
            onKeyDown={(e) => e.key === 'Enter' && handleAddTag()} // Allow Enter to add tag
          />
          <Button variant="contained" onClick={handleAddTag} startIcon={<AddIcon />}>
            Créer
          </Button>
        </Box>
      </Box>
    );
};

export default LiveHeader